export default function MisionVision() {
  return (
    <section className="mision-vision">
      <div className="container">
        <div className="section-header">
          <p className="section-overline">Nuestra empresa</p>
          <h2 className="section-title light">Misión y Visión</h2>
          <div className="section-divider" />
        </div>

        <div className="mv-grid">
          <div className="mv-card">
            <div className="mv-icon">🎯</div>
            <h3 className="mv-title">Misión</h3>
            <p className="mv-text">
              Comercializar productos de nuestra rama de la mejor calidad con un servicio
              de primera, ofreciéndoles precios justos y así satisfacer las necesidades
              de nuestros clientes.
            </p>
          </div>

          <div className="mv-divider" />

          <div className="mv-card">
            <div className="mv-icon">🔭</div>
            <h3 className="mv-title">Visión</h3>
            <p className="mv-text">
              Consolidarnos como la mejor opción en venta de aceros de la región con
              honestidad, confianza y lealtad; esforzándonos en darles la mejor calidad
              y servicio del mercado.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
